import SendEmailContainer from "@containers/SendEmailContainer/SendEmailContainer";

export default function SendEmail() {
	return (
		<div style={{ overflow: "hidden", position: "relative" }}>
			<SendEmailContainer />
		</div>
	);
}
